import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const SearchCount = ({ count, withSorting, sortingHandl }) => (
  <div className="search-cars">
    <p className="count">
      {count} cars found
    </p>
    <button className="sorting" onClick={sortingHandl} style={{ opacity: withSorting ? 1 : 0 }}>
      <i className="material-icons">filter_list</i>
    </button>
  </div>
);

SearchCount.defaultProps = {
  count: 0,
  withSorting: false,
  sortingHandl: () => {}
};

SearchCount.propTypes = {
  count: PropTypes.number,
  withSorting: PropTypes.bool,
  sortingHandl: PropTypes.func
};

export default SearchCount;




// WEBPACK FOOTER //
// ./src/components/SearchCount/index.js